import { Loading } from 'components/Loading';
import React, { ReactElement, Suspense } from 'react';
import { TTabSuspenseProps } from './TabSuspense.types';

function TabSuspense({
  element,
  elementProps = {},
}: TTabSuspenseProps): ReactElement {
  return (
    <Suspense fallback={<Loading tabLoading />}>
      {React.createElement(element, elementProps)}
    </Suspense>
  );
}

export default TabSuspense;
